<capra-toast
  type="success"
  [inline]="true"
  [showCloseBtn]="true"
  [canTapToDismiss]="false"
  (dismissToast)="dismissToast()"
>
  <div class="dataset-publish-ts-success-content">
    <p class="success-message">Publication succeeded</p>
    <capra-button-link
      data-test="ts-data-workspace-link-cta"
      [href]="publishedUrl"
      variant="secondary"
      color="neutral"
      size="small"
      text="Go to Data workspace"
      icon="icon-new-tab"
      iconLocation="right"
    ></capra-button-link>
  </div>
</capra-toast>
